import { Pill } from "src/base-components/Pill";
import { ApiKeyType } from "src/clients/taktile-api";

type Props = {
  value: ApiKeyType[];
};

export const KeyType: React.FC<Props> = ({ value }) => {
  const isLive = value.some((v) => v === ApiKeyType.LIVE);
  const isSandbox = value.some((v) => v === ApiKeyType.SANDBOX);
  const isJobAdmin = value.some((v) => v === ApiKeyType.JOB_ADMIN);
  const isHistoryAdmin = value.some((v) => v === ApiKeyType.HISTORY_ADMIN);
  const isAuditLogs = value.some((v) => v === ApiKeyType.AUDIT_LOGS);
  const isCases = value.some((v) => v === ApiKeyType.CASE_MANAGEMENT_CASES);
  const isCaseQueues = value.some(
    (v) => v === ApiKeyType.CASE_MANAGEMENT_QUEUES,
  );
  const isCaseTemplates = value.some(
    (v) => v === ApiKeyType.CASE_MANAGEMENT_TEMPLATES,
  );
  const isWsEditor = value.some((v) => v === ApiKeyType.WORKSPACE_EDITOR);
  const isWsViewer = value.some((v) => v === ApiKeyType.WORKSPACE_VIEWER);

  return (
    <div className="flex min-h-[48px] flex-wrap gap-2 py-2.5 pr-4">
      {isWsEditor && (
        <Pill size="sm" variant="orange">
          <Pill.Text>Workspace read-write</Pill.Text>
        </Pill>
      )}
      {isWsViewer && (
        <Pill size="sm" variant="gray">
          <Pill.Text>Workspace read-only</Pill.Text>
        </Pill>
      )}
      {isLive && (
        <Pill size="sm" variant="green">
          <Pill.Text>Live</Pill.Text>
        </Pill>
      )}
      {isSandbox && (
        <Pill size="sm" variant="gray">
          <Pill.Text>Sandbox</Pill.Text>
        </Pill>
      )}
      {isJobAdmin && (
        <Pill size="sm" variant="gray">
          <Pill.Text>Jobs</Pill.Text>
        </Pill>
      )}
      {isHistoryAdmin && (
        <Pill size="sm" variant="gray">
          <Pill.Text>History</Pill.Text>
        </Pill>
      )}
      {isAuditLogs && (
        <Pill size="sm" variant="gray">
          <Pill.Text>Audit Logs</Pill.Text>
        </Pill>
      )}
      {isCases && (
        <Pill size="sm" variant="gray">
          <Pill.Text>Cases</Pill.Text>
        </Pill>
      )}
      {isCaseQueues && (
        <Pill size="sm" variant="gray">
          <Pill.Text>Case Queues</Pill.Text>
        </Pill>
      )}
      {isCaseTemplates && (
        <Pill size="sm" variant="gray">
          <Pill.Text>Case Templates</Pill.Text>
        </Pill>
      )}
    </div>
  );
};
